<div style="background-color: #ffffff;">
    <router-outlet></router-outlet>
</div>